module.exports = __webpack_public_path__ + "static/media/the1device_dark3-fs8.50461b6a.jpg";